import React from 'react';
import PropTypes from "prop-types";

import moment from 'moment';
import _ from "lodash";

import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions';


// react component for creating dynamic tables
import ReactTable from 'react-table';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import OrgSelector from "views/Orgs/OrgSelector.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import { reactTableDefaultProps } from 'helpers/reactTable';

import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

import CreateMemberForm from 'views/Forms/CreateMemberForm';
import { fromE164 } from 'helpers/phoneNumber';
import defaultAvatar from "assets/img/placeholder.jpg";
import SweetAlert from 'react-bootstrap-sweetalert/lib/dist/SweetAlert';
import { deleteMember } from 'db';
import { ROLES } from 'constants/user';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    fontWeight: "bold"
  },
  circle: {
    borderRadius: "50%",
    maxWidth: "48px",
    marginRight: 18,
    marginLeft: 22,
  },
  left: {
    textAlign: "left",
  },
};


class MemberManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newMemberModalIsOpen: false,
      isEdit: false,
      uid: null,
      member: null,
      unsubscribe: null,
      alert: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.org && props.org.currentOrg !== state.currentOrg) {

      const org_id = props.org.currentOrg
        ? props.org.currentOrg.id
        : null;
      if (org_id) {
        if (state.unsubscribe) {
          state.unsubscribe();
        }
        return {
          currentOrg: props.org.currentOrg,
          unsubscribe: props.getMembersAction(org_id)
        }
      }
    }
    return null;
  }

  componentWillUnmount() {
    if (this.state.unsubscribe) {
      this.state.unsubscribe();
    }
  }
  requestClose = () => { this.closeNewMemeberModal() }

  openNewMemberModal = () => this.setState({ newMemberModalIsOpen: true });
  closeNewMemeberModal = () => this.setState({ newMemberModalIsOpen: false });

  render() {
    const { classes, currentRole, members } = this.props;
    return (
      <Container>
        <Row>
          <OrgSelector color={this.props.color} />
        </Row>
        <Row>
          <Col>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>대상자 프로파일</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col className='text-right'>
                    <Button
                      color="primary"
                      onClick={() => {
                        const { currentOrg } = this.props;
                        if (!currentOrg) {
                          return;
                        }

                        this.setState({
                          uid: null,
                          isEdit: false,
                          member: null
                        }, () => this.openNewMemberModal());
                      }}>신규 대상자 등록</Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <ReactTable
                      {...reactTableDefaultProps}
                      data={members}
                      columns={[
                        {
                          id: 'name',
                          Header: "이름",
                          width: 180,
                          accessor: d => <div className={classes.left}>
                            <img className={classes.circle} src={d.data().profile_image_url || defaultAvatar} />{d.data().name}
                          </div>,
                          filterMethod: (filter, row) => {
                            return row["name"].props.children[1].toLowerCase().search(filter.value.toLowerCase()) > -1;
                          },
                        },
                        {
                          id: 'gender',
                          Header: "성별",
                          width: 100,
                          accessor: d => d.data().gender === 0 ? "여" : "남"
                        },
                        {
                          id: 'age',
                          Header: "나이",
                          width: 100,
                          accessor: d => {
                            const { birthday: rawBirthday } = d.data();
                            const birthday = rawBirthday.constructor.name !== "String"
                              ? moment(birthday?.toDate())
                              : moment(rawBirthday);
                            return `${moment().diff(birthday, 'years')}세`
                          }
                        },
                        {
                          id: 'phone',
                          Header: "전화번호",
                          accessor: d => fromE164(d.data().phone)
                        },
                        {
                          id: 'email',
                          Header: "이메일",
                          accessor: d => d.data().email
                        },
                        {
                          id: "moved_in_at",
                          Header: "가입일",
                          accessor: d => {
                            const moved_in_at = d.data().moved_in_at;
                            return moment(moved_in_at ? moved_in_at.toDate() : null).format('YYYY-MM-DD')
                          }
                        },
                        {
                          id: "action",
                          Header: "명령",
                          accessor: d => {
                            const member = d.data();
                            return (
                              // we've added some custom button actions
                              <div className="actions-right">
                                {/* use this button to add a edit kind of action */}
                                <Button
                                  justIcon
                                  round
                                  simple
                                  onClick={(e) => {
                                    this.setState({
                                      uid: d.id,
                                      isEdit: true,
                                      member
                                    }, () => this.openNewMemberModal());
                                    e.stopPropagation();
                                  }}
                                  color="warning"
                                  className="edit"
                                >
                                  <Edit />
                                </Button>{" "}
                                {
                                  [ROLES.ORG_ADMIN, ROLES.SUPER_ADMIN].includes(currentRole.role)
                                    ? <Button
                                      justIcon
                                      round
                                      simple
                                      onClick={(e) => {
                                        this.setState({
                                          alert: (
                                            <SweetAlert
                                              warning
                                              style={{ display: "block", marginTop: "-100px" }}
                                              title="삭제 하시겠습니까?"
                                              onConfirm={() => {
                                                const org_id = this.props.org.currentOrg.id;
                                                const uid = d.id;
                                                // return deleteMember(org_id, uid)
                                                return this.props.deleteMemberAction(uid, org_id)
                                                  .then(() => {
                                                    this.setState({
                                                      alert: null
                                                    });
                                                    return this.props.showAlertAction({
                                                      message: `삭제되었습니다.`,
                                                      color: 'danger',
                                                    })
                                                  })
                                              }}
                                              onCancel={() => this.setState({
                                                alert: null
                                              })}
                                              confirmBtnCssClass={
                                                this.props.classes.button + " " + this.props.classes.success
                                              }
                                              cancelBtnCssClass={
                                                this.props.classes.button + " " + this.props.classes.danger
                                              }
                                              confirmBtnText="네 삭제합니다."
                                              cancelBtnText="취소"
                                              showCancel
                                            >
                                              한번 삭제하면 복구가 불가능합니다.
                                            </SweetAlert>
                                          )
                                        })
                                        e.stopPropagation();
                                      }}
                                      color="danger"
                                      className="remove"
                                    >
                                      <Close />
                                    </Button>
                                    : null
                                }

                              </div>
                            )
                          },
                          sortable: false,
                          filterable: false
                        }
                      ]}
                      getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                          return {
                            onClick: e => {

                              const d = rowInfo.original;

                              this.setState({
                                uid: d.id,
                                isEdit: true,
                                member: d.data()
                              }, () => {
                                this.props.history.push('/admin/gradedPersonProfile',
                                  {
                                    gradedPerson: {
                                      ...d.data(),
                                      uid: d.id
                                    },
                                    org_id: this.props.org.currentOrg.id
                                  });
                              });
                            },
                            style: {
                              cursor: 'pointer'
                            }
                          };
                        } else {
                          return {};
                        }
                      }}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Modal
            isOpen={this.state.newMemberModalIsOpen}
            toggle={this.requestClose}
            size='lg'
          >
            <ModalHeader>{this.state.isEdit ? '대상자 수정' : '신규 대상자 등록'}</ModalHeader>
            <ModalBody>
              <CreateMemberForm
                onClose={this.closeNewMemeberModal}
                isEdit={this.state.isEdit}
                uid={this.state.uid}
                member={this.state.member}
              />
            </ModalBody>
          </Modal>
          {this.state.alert}
        </Row>
      </Container>
    );
  }
}


MemberManager.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    members: state.member.members,
    org: state.org,
    currentOrg: state.org.currentOrg,
    currentRole: state.auth.currentRole
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}


export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(MemberManager);